import { el } from '/lib/redom.es.js';

import SVG from '/components/core/svg/index.js';

class Spinner {

  constructor(configuration = {}) {

    this.size = configuration.size;

    this.el = el('.spinner', {
      style: this.buildStyles()
    }, [new SVG({
      src: '/images/spinner.svg'
    })]);

  }

  buildStyles() {

    if (this.size === 'small') {
      return {
        width: '15px',
        height: '15px'
      };
    }

    return {
      width: '30px',
      height: '30px'
    };

  }

}

export default Spinner;